import { Redirect, useParams } from "react-router-dom";

const RedirectDashboardToProfile = () => {
  const { userId: userIdStr } = useParams<{
    userId: string | undefined;
  }>();
  const userId = userIdStr ? parseInt(userIdStr) : undefined;

  if (!userId) {
    return <Redirect to="/" />;
  }
  return <Redirect to={`/profile/${userId}`} />;
};

export default RedirectDashboardToProfile;
